import { Typography } from "@mui/material";

import { lightOrDark } from "@app/embedded/theme/utils";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

type SelfRemoveAccessConfirmProps = Omit<ConfirmationModalProps, "children">;

const SelfRemoveAccessConfirm = (props: SelfRemoveAccessConfirmProps) => (
  <ConfirmationModal {...props} title="Change your permissions?" size="md">
    <Typography
      sx={{
        color: (theme) =>
          lightOrDark("shades.neutral.600", "shades.neutral.100")(theme),
        lineHeight: 20 / 16,
      }}
    >
      When you remove yourself from{" "}
      <span style={{ fontWeight: 500 }}>people with access</span>, you will no
      longer be able to view this report (unless link access allows you to do
      so).
    </Typography>
  </ConfirmationModal>
);

export default SelfRemoveAccessConfirm;
